import React from 'react'

const style = {
    minWidth: 250,
    fontSize: 20
} as React.CSSProperties

export default (props: Button) => {
    return (<button disabled={props.disabled} className={props.classList} type="button" onClick={props.onButtonClick} style={props.style}>{props.value}</button>)
}

interface Button {
    classList: string,
    value: any,
    onButtonClick: () => void,
    style: any,
    disabled: boolean
}
